import React, { useEffect, useState } from "react";



const Loader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // After 5 seconds, fade out the loader
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // Adjust the time as needed if a longer loading time is expected
    
    return () => clearTimeout(timer);
  }, [])

  return (
    <div
      className={`fixed top-0 left-0 right-0 bottom-0 bg-gray-300 bg-opacity-100 flex justify-center items-center z-50 ${
        isVisible ? "opacity-100" : "opacity-0"
      } transition-opacity duration-1000 ease-in-out`}
    >
      <img src="/logo.png" alt="PZ logo" className="w-24" />
    </div>
  );
};

export default Loader;
